import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Popper } from 'react-popper';
import { withTheme } from 'emotion-theming';

var getRtlPlacement = function getRtlPlacement(placement) {
  var rtlPlacementMap = {
    end: 'start',
    start: 'end'
  };

  var _placement$split = placement.split('-'),
      edge = _placement$split[0],
      direction = _placement$split[1];

  if (['bottom', 'top'].indexOf(edge) !== -1) {
    return placement.replace(direction, rtlPlacementMap[direction]);
  }

  return placement;
}; // eslint-disable-next-line react/display-name


function RtlPopper(_ref) {
  var placement = _ref.placement,
      theme = _ref.theme,
      restProps = _objectWithoutPropertiesLoose(_ref, ["placement", "theme"]);

  var rootProps = _objectSpread({
    placement: placement && theme.direction === 'rtl' ? getRtlPlacement(placement) : placement
  }, restProps);

  return ___EmotionJSX(Popper, rootProps);
}

export default withTheme(RtlPopper);